document.addEventListener('DOMContentLoaded', () => {
  let isUpdating = false;
  let updateQueue = [];

  function formatMoney(cents) {
    return (cents/100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    
    // Check if cart drawer exists and has content
    if (!cartDrawer || !cartDrawer.querySelector('.cart-drawer-box')) {
        // Fetch and insert cart drawer if missing
        fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawer = doc.querySelector('.cart-drawer');
                
                if (newDrawer) {
                    // If there's an existing empty drawer, replace it
                    if (cartDrawer) {
                        cartDrawer.replaceWith(newDrawer);
                    } else {
                        // If no drawer exists, append to body
                        document.body.appendChild(newDrawer);
                    }
                    
                    // Add listeners and open drawer
                    addListeners();
                    setTimeout(() => {
                        document.querySelector('.cart-drawer').classList.add('cart-drawer--active');
                    }, 100);
                }
            })
            .catch(error => {
                console.error('Error loading cart drawer:', error);
                // Optionally show an error message to the user
                alert('Unable to load cart. Please refresh the page and try again.');
            });
        return;
    }
    
    // Normal opening if drawer exists
    cartDrawer.classList.add('cart-drawer--active');
    document.addEventListener('click', closeDrawerOnClickOutside);
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('cart-drawer--active');
      document.removeEventListener('click', closeDrawerOnClickOutside);
    }
  }

  function closeDrawerOnClickOutside(event) {
    const cartDrawerBox = document.querySelector('.cart-drawer-box');
    if (cartDrawerBox && !cartDrawerBox.contains(event.target) && !event.target.closest('.cart-header-button')) {
      closeCartDrawer();
    }
  }

  function updateCartItemCounts(count) {
    document.querySelectorAll('.cart-drawer-header-right-items').forEach((el) => {
      el.textContent = count === 1 ? '1 item' : `${count} items`;
    });
  }

  function toggleMaxQuantityMessage(selector, show) {
    const message = selector.querySelector('.max-quantity-message');
    if (message) {
      message.style.display = show ? 'block' : 'none';
    }
  }

  function updateCartTotals(cart) {
    const totalElement = document.querySelector('.cart-drawer-footer-row span');
    if (totalElement) {
      totalElement.textContent = formatMoney(cart.total_price);
    }

    const checkoutButton = document.querySelector('.cart-drawer-button');
    if (checkoutButton) {
      checkoutButton.textContent = `Checkout • ${formatMoney(cart.total_price)}`;
    }
  }

  async function updateCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const text = await res.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const newBox = html.querySelector('.cart-drawer').innerHTML;
      const currentDrawer = document.querySelector('.cart-drawer');
      if (currentDrawer) {
        currentDrawer.innerHTML = newBox;
        addListeners();
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }

  async function processCartUpdate(lineItemKey, quantity, itemContainer) {
    if (isUpdating) {
        updateQueue.push({ lineItemKey, quantity, itemContainer });
        return;
    }

    isUpdating = true;
    
    try {
        // Show loading state
        if (itemContainer) {
            itemContainer.classList.add('loading');
            document.querySelectorAll('.cart-drawer-quantity-selector button').forEach(btn => {
                btn.disabled = true;
            });
            const footer = document.querySelector('.cart-drawer-footer');
            if (footer) footer.classList.add('loading');
        }

        // Perform the cart update
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineItemKey, quantity }),
        });

        if (!response.ok) throw new Error('Cart update failed');
        
        // Wait for the update to process
        await new Promise(resolve => setTimeout(resolve, 500));

        // Refresh the entire cart drawer
        await updateCartDrawer();

        // Get fresh cart data
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Update counts and totals with fresh data
        updateCartItemCounts(cart.item_count);
        updateCartTotals(cart);

    } catch (error) {
        console.error('Cart update error:', error);
        // Refresh cart drawer on error to ensure correct state
        await updateCartDrawer();
    } finally {
        isUpdating = false;

        // Process next update in queue if any
        if (updateQueue.length > 0) {
            const nextUpdate = updateQueue.shift();
            await processCartUpdate(nextUpdate.lineItemKey, nextUpdate.quantity, nextUpdate.itemContainer);
        }
    }
  }

  function addListeners() {
    const cartHeaderButton = document.querySelector('.cart-header-button');
    if (cartHeaderButton) {
      cartHeaderButton.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    }

    document.querySelectorAll('.cart-drawer-header-right-close').forEach((btn) => {
      btn.addEventListener('click', closeCartDrawer);
    });

    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        try {
          await fetch('/cart/add', { 
            method: 'POST', 
            body: new FormData(form) 
          });
          
          // Wait for cart to update
          await new Promise(resolve => setTimeout(resolve, 500));
          
          const res = await fetch('/cart.js');
          const cart = await res.json();
          updateCartItemCounts(cart.item_count);
          await updateCartDrawer();
          openCartDrawer();
        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    });

    document.querySelectorAll('.cart-drawer-quantity-selector').forEach((selector) => {
      const minusButton = selector.querySelector('.cart-drawer-quantity-selector-minus');
      const plusButton = selector.querySelector('.cart-drawer-quantity-selector-plus');
      const input = selector.querySelector('input');
      const itemContainer = selector.closest('.cart-drawer-item');
      const lineItemKey = itemContainer.dataset.lineItemKey;
      const maxQuantity = parseInt(input.dataset.maxQuantity) || 99;

      minusButton.addEventListener('click', () => {
        if (isUpdating) return;
        const currentQuantity = parseInt(input.value, 10) || 1;
        
        if (currentQuantity > 1) {
          processCartUpdate(lineItemKey, currentQuantity - 1, itemContainer);
        } else if (confirm('Remove this item from cart?')) {
          processCartUpdate(lineItemKey, 0, itemContainer);
        }
      });

      plusButton.addEventListener('click', () => {
        if (isUpdating || plusButton.disabled) return;
        const currentQuantity = parseInt(input.value, 10) || 0;
        const newQuantity = currentQuantity + 1;
        
        if (newQuantity > maxQuantity) {
          toggleMaxQuantityMessage(selector, true);
          return;
        }
        
        processCartUpdate(lineItemKey, newQuantity, itemContainer);
      });

      input.addEventListener('change', () => {
        if (isUpdating) return;
        let newQuantity = parseInt(input.value, 10) || 0;
        
        if (newQuantity > maxQuantity) {
          toggleMaxQuantityMessage(selector, true);
          newQuantity = maxQuantity;
        }
        
        if (newQuantity < 0) newQuantity = 0;
        
        if (newQuantity === 0) {
          if (confirm('Remove this item from cart?')) {
            processCartUpdate(lineItemKey, 0, itemContainer);
          } else {
            processCartUpdate(lineItemKey, 1, itemContainer);
          }
        } else {
          processCartUpdate(lineItemKey, newQuantity, itemContainer);
        }
      });

      input.addEventListener('keypress', (e) => {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      });
    });

    document.querySelectorAll('.cart-drawer-item-remove').forEach((btn) => {
      const itemContainer = btn.closest('.cart-drawer-item');
      const lineItemKey = itemContainer.dataset.lineItemKey;
      btn.addEventListener('click', () => {
        if (isUpdating) return;
        if (confirm('Remove this item from cart?')) {
          processCartUpdate(lineItemKey, 0, itemContainer);
        }
      });
    });
  }

  // Initialize
  addListeners();
});